<template>
    <div>
        <div class="form-row col-12 px-0">
            <div class="col-md-6 form-group">
                <datepicker-accessible
                    :label-single="'Od'"
                    custom-id="date-from"
                    name="date-from"
                    mode="date"
                    :use_pencil_checkbox="false"
                    :strong_label="false"
                    v-model="dateFrom"
                ></datepicker-accessible>
                <small class="text-red small-70" v-if="!validDate">
                    {{ $lang('Data musi być wcześniejsza niż data końcowa') }}
                </small>
            </div>

            <div class="col-md-6 form-group">
                <datepicker-accessible
                    :label-single="'Do'"
                    custom-id="date-to"
                    name="date-to"
                    mode="date"
                    :use_pencil_checkbox="false"
                    :strong_label="false"
                    v-model="dateTo"
                ></datepicker-accessible>
                <small class="text-red small-70" v-if="!validDate">
                    {{ $lang('Data musi być późniejsza niż data początkowa') }}
                </small>
            </div>
        </div>

        <div class="form-group">
            <label for="statuses">{{$lang('Statusy')}}</label>
            <multiselect
                :searchable=false :close-on-select=false
                id="statuses" v-model="selectedStatuses" :options="allStatuses"
                group-values="options" group-label="label" :group-select="true"
                :multiple="true" label="name" track-by="id"
                :placeholder="$lang('Wybierz statusy')"
                :selectLabel="$lang('Wybierz status')"
                :selectedLabel="$lang('Wybrane')"
                :deselectLabel="$lang('Usuń status')"
                :selectGroupLabel="$lang('Wybierz wszystkie statusy')"
                :deselectGroupLabel="$lang('Usuń wszystkie statusy')"
            ></multiselect>

            <input v-for="status in selectedStatuses" name="statuses[]" :value="status.id" hidden>
        </div>

        <div class="form-group">
            <label for="performers">{{$lang('Osoby techniczne')}}</label>
            <multiselect
                :searchable=false :close-on-select=false
                id="performers" v-model="selectedPerformers" :options="allPerformers"
                group-values="options" group-label="label" :group-select="true"
                :multiple="true" track-by="id"
                :custom-label="fullName"
                :placeholder="$lang('Wybierz osoby')"
                :selectLabel="$lang('Wybierz osobę')"
                :selectedLabel="$lang('Wybrane')"
                :deselectLabel="$lang('Usuń osobę')"
                :selectGroupLabel="$lang('Wybierz wszystkie osoby')"
                :deselectGroupLabel="$lang('Usuń wszystkie osoby')"
            ></multiselect>

            <input v-for="performer in selectedPerformers" name="performers[]" :value="performer.id" hidden>
        </div>

        <div class="form-group">
            <label for="applicant">{{$lang('Zgłaszający')}}</label>
            <select id="applicant" name="applicant" class="form-control">
                <option value='all'>{{$lang('wszystkie')}}</option>
                <option value='sbs'>{{$lang('tylko SBS')}}</option>
                <option value='others'>{{$lang('tylko klienci')}}</option>
            </select>
        </div>


    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import ValidDate from "../../../mixins/report-valid-date";

    export default {
        name: 'tasks-with-status-inputs',
        components: {Multiselect},
        mixins: [ValidDate],
        props: ['statuses', 'performers'],
        data() {
            return {
                selectedStatuses: [],
                selectedPerformers: [],
                allStatuses: [{
                    label: 'Wszystkie',
                    options: this.statuses
                }],
                allPerformers: [{
                    label: 'Wszystkie',
                    options: this.performers
                }]
            }
        },
        computed: {
            valid() {
                return this.selectedStatuses.length > 0 && this.selectedPerformers.length > 0
                    && this.dateFrom !== '-' && this.dateTo !== '-' && this.dateFrom <= this.dateTo;
            }
        },
        watch: {
            valid() {
                this.$emit('validation', this.valid);
            },
        },
        methods: {
            fullName({name, surname}) {
                return surname + ' ' + name
            }
        },
        created() {
            const date = new Date();
            this.dateFrom = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) +'-01';
            this.dateTo = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
            this.performers.push({id: null, name: '-', surname: ''});
        }
    }
</script>
